import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faTwitter, faInstagram, faGithub, faYoutube, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faCamera, faEarthAmericas, faPaperPlane, faPhone, faHexagonNodesBolt, faXmark, faHouse, faAddressCard, faBriefcase, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import NavigationZone from "./NavigationZone";
import { useLocation } from "react-router-dom";



const Animations = () => {
  const [isFlxVisible, setIsFlxVisible] = useState(false);
  const [isFlx2Visible, setIsFlx2Visible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const betterRef = useRef(null);
  const flxRef = useRef(null);
  const flx2Ref = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false)
  const [showFixBar, setShowFixBar] = useState(false)
  const [shouldAnimate, setShouldAnimate] = useState(false); // Tracks animation trigger
  const goHomePage = useNavigate()
  const workPage = useNavigate()

  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // Delay ensures it's applied after navigation

  }, [pathname]);

 


 
 
  


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.1 } // Adjust threshold as needed
    );

    if (betterRef.current) {
      observer.observe(betterRef.current);
    }

    return () => observer.disconnect();
  }, []);
  
  
  // Intersection Observer to handle visibility
  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.target.id === "flx") {
          setIsFlxVisible(entry.isIntersecting);
        } else if (entry.target.classList.contains("flx2")) {
          setIsFlx2Visible(entry.isIntersecting);
        }
      });
    };

    const observerOptions = {
      root: null, // Viewport as root
      threshold: 0.1, // Trigger when 10% of the element is visible
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (flxRef.current) observer.observe(flxRef.current);
    if (flx2Ref.current) observer.observe(flx2Ref.current);

    return () => {
      if (flxRef.current) observer.unobserve(flxRef.current);
      if (flx2Ref.current) observer.unobserve(flx2Ref.current);
    };
  }, []);

  return (
    <div className="let">
      <div className="anima-tion">
      <NavigationZone />





     {/* SECTION 2 */}
        <div className="section2">
        </div>

        {/* SECTION 3 */}
        <div className="section3">
          <div className="placeThem">
          <h1 className="journey">I am Ayomide Lit and I am a freelance Software Developer</h1>
<p className="belowJourney">I have a personal philosophy in life: If somebody else can 
do something that I'm doing, they should do it. And what I 
want to do is find things that would represent a unique 
contribution to the world  - the  contribution that only I, 
and my portfolio of talents, can make happen. Those are 
my priorities in life. <br />
My willingness to adapt to new tools and challenges ensures that I can 
 integrate into any project, no matter the complexity.I am enthusiastic 
 about taking on roles that push my boundaries and contribute to the  team's success.
</p>
<p className="darkLine"></p>
<div className="socials">
 
<a href="https://github.com/LIT-codes1" target="_blank"  className="faceBook">
  <FontAwesomeIcon icon={faGithub} />
  </a>

  <a href="https://x.com/lit_webdev" target="_blank" className="faceBook">
  <FontAwesomeIcon icon={faTwitter} />
  </a>


  <a href='https://www.instagram.com/heis__lit/' target="_blank" className="faceBook">
  <FontAwesomeIcon icon={faInstagram} />
  </a>


  <a href="https://wa.me/2349077277666" target="_blank" className="faceBook">
  <FontAwesomeIcon icon={faWhatsapp} />
  </a>
</div>
          </div>
        <img className="myPic" src="fineMan.PNG" alt="Description of image" />
        </div>
      </div>

<div       ref={betterRef}
      className={`better ${isVisible ? 'fade-in' : 'hidden'}`}
>
  <div className="doings">
  <h1 className="">What I Love Doing</h1>
  </div>
  <div className="fish1">
  <p className="belowDoings">It's tough to keep on top of everything. I approach every task with dedication. What I do, I strive to perfect.</p>
  </div>
<div className="love">
  <div className="num1">
  <FontAwesomeIcon icon={faDesktop} className="IconUnderLove"/>
  <h1>Web / User Interface</h1>
  <p>I enjoy crafting responsive designs, optimizing user experiences, and solving complex problems with clean, efficient code</p>
  </div>

  <div className="num1">
  <FontAwesomeIcon icon={faCamera} className="IconUnderLove"/>
  <h1>Visionary Photography</h1>
  <p>I bring more than just code to the table, I bring life to your website. I specialize  in capturing images that tell a story and evoke emotion, ensuring your visuals resonate with your audience. </p>
  </div>

  <div className="num1">
  <FontAwesomeIcon icon={faEarthAmericas} className="IconUnderLove"/>
  <h1>Team Work</h1>
  <p>As a developer, I thrive in collaborative environments where creativity and problem-solving come together. I have a strong ability to work with other developer as a cohesive team.</p>
  </div>

  <div className="num1">
  <FontAwesomeIcon icon={faPhone} className="IconUnderLove"/>
  <h1>Unlimited Support</h1>
  <p>
  Capture awe-inspiring photographs that leave a lasting impression and provide exceptional support to clients.</p>
  </div>

  <div className="num1">
  <FontAwesomeIcon icon={faPaperPlane} className="IconUnderLove"/>
  <h1>Web Hosting</h1>
 <p>Responsive, interactive and clean websites and apps for all User</p>
  </div>



  <div className="num1">
  <FontAwesomeIcon icon={faHexagonNodesBolt} className="IconUnderLove"/>
  <h1>Web / User Interface</h1>
  <p>I have a passion for learning new languages, both in programming and in communication, as I believe it fuels my creativity and broadens my perspective.</p>
  </div>
</div>
</div>
      <div className="stage">
        {/* Multiple stage sections */}
        {/* {[...Array(3)].map((_, index) => (
          <div className="stage2" key={index}>
            <div className="flx1">
              <p>hello</p>
            </div>
            <div className="flx2">
              <p>hello</p>
            </div>
          </div>
        ))} */}

        {/* Section with visibility control */}
        {/* <div className="stage2">
          <div
            id="flx"
            ref={flxRef}
            className={`flx ${isFlxVisible ? "visible" : ""}`}
          >
            <p>Hello from flx</p>
          </div>
          <div
            className={`flx2 ${isFlx2Visible ? "visible" : ""}`}
            ref={flx2Ref}
          >
            <p>Hello from flx2</p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Animations;
